<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="./">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>系统参数</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 主体内容 -->
    <div class="content">
      <!-- 列表查询 -->
      <el-card class="box-card table">
        <div slot="header" class="clearfix">
          <span>系统参数配置</span>
        </div>
        <el-form
          :model="form"
          ref="form"
          label-width="100px"
          :status-icon="true"
          @submit.native.prevent="submitForm('form')"
        >
          <el-alert type="warning" :closable="true">
            <b>系统参数配置，影响系统运行和结算，请谨慎操作！</b>
          </el-alert>
          <br />

          <el-form-item
            label="系统名称"
            prop="sysName"
            :rules="[{ required: true, message: '请输入系统名称' }]"
          >
            <el-input
              v-model="form.sysName"
              placeholder="请输入系统名称"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="公司名称"
            prop="company"
            :rules="[{ required: true, message: '请输入公司名称' }]"
          >
            <el-input
              v-model="form.company"
              placeholder="请输入公司名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="公司地址" prop="siteDetail" :rules="[]">
            <el-input
              v-model="form.siteDetail"
              placeholder="请输入详细地址"
            ></el-input>
          </el-form-item>
          <el-divider content-position="left">小程序测评</el-divider>
          <el-form-item
            label="测评标题"
            prop="evaTitle"
            :rules="[{ required: true, message: '请输入测评标题' }]"
          >
            <el-input
              v-model="form.evaTitle"
              placeholder="请输入测评标题"
            ></el-input>
          </el-form-item>
          <!-- 说明页已改为纯图片，小贴士文案暂不展示；需要时再打开
          <el-form-item label="答题小贴士" prop="evaTips">
            <el-input
              type="textarea"
              v-model="form.evaTips"
              placeholder="请输入答题小贴士"
            ></el-input>
          </el-form-item>
          -->
          <el-form-item label="测评顶部图片">
            <div id="uploadBtnEva" class="uploader uploader-warning"></div>
            <img
              id="relativeName"
              :src="domain + form.evaImage"
              style="height: 40px; position: relative; left: 10px; top: 20px"
              v-if="form.evaImage"
            />
            <span class="red" style="margin-left:20px;">*注：答题页顶部图，推荐尺寸：680*290</span>
          </el-form-item>
          <el-form-item label="测评页背景">
            <div id="uploadBtnEvaBg" class="uploader uploader-warning"></div>
            <img
              v-if="form.evaBgImg"
              :src="domain + form.evaBgImg"
              style="height: 60px; position: relative; left: 10px; top: 16px; border-radius: 4px;"
            />
            <el-button
              v-if="form.evaBgImg && form.evaBgImg !== '/wximg/test_explain_bg_02.png'"
              type="text"
              style="margin-left: 12px;"
              @click="$set(form, 'evaBgImg', '/wximg/test_explain_bg_02.png')"
            >恢复默认</el-button>
            <div style="color:#999;font-size:12px;margin-top:8px;line-height:1.5;">
              说明页整页视觉图（标题、小贴士文案、插画等请一并做进图内）。页面上仅再叠加「开始测评」按钮。建议竖屏整页设计，宽 ≥750px。
            </div>
          </el-form-item>
          <el-form-item
            label="通用规则说明"
            prop="evaSummary"
          >
            <el-input
              type="textarea"
              :rows="3"
              v-model="form.evaSummary"
              placeholder="未配置某学历专用文案时使用此兜底说明（建议写共30题、不限定单一学历）"
            ></el-input>
          </el-form-item>
          <el-form-item label="按学历规则说明">
            <div
              v-for="item in eduSummaryList"
              :key="item.id"
              style="margin-bottom:12px"
            >
              <div style="font-weight:bold;margin-bottom:4px;color:#606266">
                {{ item.name }}
              </div>
              <el-input
                type="textarea"
                :rows="2"
                :value="(form.evaSummaryByEdu && form.evaSummaryByEdu[item.id]) || ''"
                @input="onEduSummaryInput(item.id, $event)"
                :placeholder="'针对「' + item.name + '」的规试说明，答题页按所选学历展示'"
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item
            label="温馨提示"
            prop="evaPointer"
            :rules="[{ required: true, message: '请输入温馨提示' }]"
          >
            <el-input
              type="textarea"
              v-model="form.evaPointer"
              placeholder="请输入温馨提示"
            ></el-input>
            <div style="color:#999;font-size:12px;margin-top:6px;">展示在测评结果页底部，保存长图时也会带上</div>
          </el-form-item>
          <el-divider content-position="left">小程序分享</el-divider>
          <el-form-item label="首页Slogan" prop="homeSlogan">
            <el-input
              v-model="form.homeSlogan"
              placeholder="小程序首页标语"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="订阅模板ID" prop="subscribeTemplateId">
            <el-input
              v-model="form.subscribeTemplateId"
              placeholder="考试报名截止提醒模板ID"
            ></el-input>
            <div style="color:#999;font-size:12px;margin-top:4px">
              固定模板：考试报名截止提醒（thing1考试类型 / time2考试时间 / thing5温馨提示）
            </div>
          </el-form-item> -->
          <el-form-item label="分享配置">
            <el-button type="primary" plain @click="openShareDialog">分享配置</el-button>
            <div style="color:#999;font-size:12px;margin-top:6px;line-height:1.5;">
              按板块分别设置转发标题与卡片图；未配图时回退「首页」分享图。学校详情默认用该校头图。
            </div>
          </el-form-item>

          <el-divider content-position="left">选校页 / 详情</el-divider>
          <el-form-item label="选校顶图">
            <div id="uploadBtnSchoolTop" class="uploader uploader-warning"></div>
            <img
              v-if="form.schoolTopImg"
              :src="domain + form.schoolTopImg"
              style="height: 48px; position: relative; left: 10px; top: 16px; border-radius: 4px;"
            />
            <el-button
              v-if="form.schoolTopImg"
              type="text"
              style="margin-left: 12px;"
              @click="$set(form, 'schoolTopImg', '')"
            >清除</el-button>
          </el-form-item>
          <el-form-item label="VR占位图">
            <div id="uploadBtnVrComing" class="uploader uploader-warning"></div>
            <img
              v-if="form.vrComingSoonImg"
              :src="domain + form.vrComingSoonImg"
              style="height: 60px; position: relative; left: 10px; top: 16px; border-radius: 4px;"
            />
            <el-button
              v-if="form.vrComingSoonImg"
              type="text"
              style="margin-left: 12px;"
              @click="$set(form, 'vrComingSoonImg', '')"
            >清除</el-button>
            <div style="color:#999;font-size:12px;margin-top:8px;line-height:1.5;">
              学校未上传 720VR 时展示。推荐 16:9，宽 ≥750px。
            </div>
          </el-form-item>

          <el-divider content-position="left">小程序加载页</el-divider>
          <el-form-item label="加载图标">
            <div id="uploadBtnPageLoading" class="uploader uploader-warning"></div>
            <img
              v-if="form.pageLoadingImg"
              :src="domain + form.pageLoadingImg"
              style="height: 60px; position: relative; left: 10px; top: 16px; border-radius: 4px;"
            />
            <el-button
              v-if="form.pageLoadingImg"
              type="text"
              style="margin-left: 12px;"
              @click="$set(form, 'pageLoadingImg', '')"
            >清除</el-button>
            <div style="color:#999;font-size:12px;margin-top:8px;line-height:1.5;">
              页面切换时的加载图。上传后使用自定义图（居中缩放动画）；清除后恢复默认五色爱心。建议透明底 PNG，体积尽量小（如 ≤100KB），避免加载蒙层一闪而过。
            </div>
          </el-form-item>

          <el-divider content-position="left">VIP 专属菜单（仅两项）</el-divider>
          <el-form-item label="申请进度">
            <el-input v-model="form.vipMenuProgress" placeholder="申请进度"></el-input>
            <div style="color:#999;font-size:12px;margin-top:4px">固定入口</div>
          </el-form-item>
          <el-form-item label="菜单名称">
            <el-input v-model="form.vipMenuSuggest" placeholder="行前指导调查"></el-input>
            <div style="color:#999;font-size:12px;margin-top:4px">题目配置请到「行前指导调查」页点击「题目配置」</div>
          </el-form-item>

          <el-divider content-position="left">案例页 Tab 名称</el-divider>
          <el-form-item label="菜单名称">
            <el-input v-model="form.caseTabLang" placeholder="语言学校"></el-input>
          </el-form-item>
          <el-form-item label="菜单名称">
            <el-input v-model="form.caseTabGrad" placeholder="研究生预科"></el-input>
          </el-form-item>
          <el-form-item label="菜单名称">
            <el-input v-model="form.caseTabPath" placeholder="在日进路"></el-input>
            <div style="color:#999;font-size:12px;margin-top:4px">对应案例页顶部三个入口文案</div>
          </el-form-item>

          <el-divider content-position="left">联系方式</el-divider>
          <el-form-item
            label="邮箱"
            prop="email"
            :rules="[
              { required: true, message: '请输入邮箱' },
              { type: 'email', message: '邮箱格式不正确' },
            ]"
          >
            <el-input
              v-model="form.email"
              placeholder="请输入公司名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="mobile" :rules="[]">
            <el-input
              v-model="form.mobile"
              placeholder="请输入手机号"
            ></el-input>
          </el-form-item>
          <el-form-item label="微信" prop="wechat">
            <el-input
              v-model="form.wechat"
              placeholder="请输入微信号"
            ></el-input>
          </el-form-item>
          <el-form-item label="客服链接" prop="serviceLink" :rules="[]">
            <el-input
              v-model="form.serviceLink"
              placeholder="请输入客服链接地址"
            ></el-input>
          </el-form-item>

          <!-- <el-form-item
            label="骑手佣金"
            prop="riderAmount"
            :rules="[{required:true,message:'不能为空'},{type:'number',message:'请填写数字'}]"
          >
            <el-input v-model.number="form.riderAmount" placeholder="请输入佣金"></el-input>
          </el-form-item>

          <el-form-item
            label="配送费"
            prop="distFee"
            :rules="[{required:true,message:'不能为空'},{type:'number',message:'请填写数字'}]"
          >
            <el-input v-model.number="form.distFee" placeholder="请输入配送费">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <el-form-item
            label="结算费率"
            prop="poundage"
            :rules="[{required:true,message:'不能为空'},{type:'number',message:'请填写数字'}]"
          >
            <el-input v-model.number="form.poundage" placeholder="请输入结算费率值"></el-input>
          </el-form-item>
          -->
          <el-form-item>
            <el-button type="primary" :loading="submiting" native-type="submit"
              >提交</el-button
            >
            <!-- <el-button @click="dialogVisible=false">取消</el-button> -->
          </el-form-item>
        </el-form>
      </el-card>
    </div>

    <el-dialog
      title="小程序分享配置"
      :visible.sync="shareDialogVisible"
      width="720px"
      @opened="initShareUploads"
    >
      <el-tabs v-model="shareTab" type="border-card">
        <el-tab-pane
          v-for="item in shareSections"
          :key="item.key"
          :label="item.label"
          :name="item.key"
        >
          <el-form label-width="90px" size="small">
            <el-form-item label="分享标题">
              <el-input
                v-model="form[item.titleProp]"
                :placeholder="item.titlePlaceholder || ('请输入' + item.label + '分享标题')"
              ></el-input>
            </el-form-item>
            <el-form-item label="分享卡片">
              <div :id="'uploadBtnShare_' + item.key" class="uploader uploader-warning"></div>
              <img
                v-if="form[item.imgProp]"
                :src="domain + form[item.imgProp]"
                style="height:48px;margin-left:10px;border-radius:4px;vertical-align:middle;"
              />
              <el-button
                v-if="form[item.imgProp]"
                type="text"
                style="margin-left:8px;"
                @click="$set(form, item.imgProp, '')"
              >清除</el-button>
              <div style="color:#999;font-size:12px;margin-top:6px;">
                推荐 5:4，约 700×560。{{ item.imgTip || '留空则用「首页」分享图。' }}
              </div>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
      <span slot="footer">
        <el-button type="primary" @click="shareDialogVisible = false">完成</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
export default {
  data() {
    return {
      domain: url.getDomain(),
      submiting: false,
      form: {}, //参数对象
      shareDialogVisible: false,
      shareTab: "home",
      shareSections: [
        { key: "home", label: "首页", titleProp: "shareTitle", imgProp: "shareImg", titlePlaceholder: "小程序首页分享标题", imgTip: "未配其它板块图时的兜底图。" },
        { key: "school", label: "选校", titleProp: "shareSchoolTitle", imgProp: "shareSchoolImg", titlePlaceholder: "如：日本语言学校选校" },
        { key: "case", label: "案例", titleProp: "shareCaseTitle", imgProp: "shareCaseImg" },
        { key: "data", label: "资料", titleProp: "shareDataTitle", imgProp: "shareDataImg" },
        { key: "active", label: "活动", titleProp: "shareActiveTitle", imgProp: "shareActiveImg" },
        { key: "video", label: "视频", titleProp: "shareVideoTitle", imgProp: "shareVideoImg" },
        { key: "test", label: "测评", titleProp: "shareTestTitle", imgProp: "shareTestImg" },
        { key: "topicFuri", label: "赴日留学", titleProp: "shareTopicFuriTitle", imgProp: "shareTopicFuriImg" },
        { key: "topicJp", label: "日语学习", titleProp: "shareTopicJpTitle", imgProp: "shareTopicJpImg" },
        { key: "topicEju", label: "EJU留考", titleProp: "shareTopicEjuTitle", imgProp: "shareTopicEjuImg" },
        { key: "topicMingye", label: "鸣野塾", titleProp: "shareTopicMingyeTitle", imgProp: "shareTopicMingyeImg" },
      ],
      eduSummaryList: [
        { id: "1", name: "初中" },
        { id: "2", name: "高中" },
        { id: "3", name: "中专高职" },
        { id: "4", name: "大专" },
        { id: "5", name: "本科" },
        { id: "6", name: "硕士" },
      ],
    };
  },
  methods: {
    openShareDialog() {
      this.ensureShareDefaults();
      this.shareDialogVisible = true;
    },
    ensureShareDefaults() {
      var defaults = {
        shareTitle: this.form.shareTitle || "木子小花，欢迎你的到来！",
        shareSchoolTitle: this.form.shareSchoolTitle || "日本语言学校选校",
        shareCaseTitle: this.form.shareCaseTitle || "留学案例",
        shareDataTitle: this.form.shareDataTitle || "留学资料",
        shareActiveTitle: this.form.shareActiveTitle || "最新活动",
        shareVideoTitle: this.form.shareVideoTitle || "探校视频",
        shareTestTitle: this.form.shareTestTitle || "职业倾向测评",
        shareTopicFuriTitle: this.form.shareTopicFuriTitle || "赴日留学",
        shareTopicJpTitle: this.form.shareTopicJpTitle || "日语学习",
        shareTopicEjuTitle: this.form.shareTopicEjuTitle || "EJU留考",
        shareTopicMingyeTitle: this.form.shareTopicMingyeTitle || "鸣野塾",
      };
      Object.keys(defaults).forEach((k) => {
        if (!this.form[k]) this.$set(this.form, k, defaults[k]);
      });
    },
    initShareUploads() {
      var _this = this;
      this.$nextTick(function () {
        _this.shareSections.forEach(function (sec) {
          var sel = "#uploadBtnShare_" + sec.key;
          var $el = $(sel);
          if (!$el.length) return;
          $el.empty();
          $el.uploader({
            url: url.getUpload(),
            text: "上传图片",
            fileExts: "jpg;png;webp",
            handleType: "0",
            maxSize: 1024 * 1024 * 0.5,
            onSuccess: function (data) {
              _this.$set(_this.form, sec.imgProp, data.relativeName);
            },
          });
        });
      });
    },
    onEduSummaryInput(id, val) {
      if (!this.form.evaSummaryByEdu) {
        this.$set(this.form, "evaSummaryByEdu", {});
      }
      this.$set(this.form.evaSummaryByEdu, String(id), val);
    },
    ensureEvaSummaryByEdu(data) {
      var map = data.evaSummaryByEdu || data.EvaSummaryByEdu || {};
      if (typeof map !== "object" || Array.isArray(map)) map = {};
      var normalized = {};
      this.eduSummaryList.forEach((item) => {
        normalized[item.id] = map[item.id] || map[Number(item.id)] || "";
      });
      data.evaSummaryByEdu = normalized;
      return data;
    },
    //获取配置信息
    getConfig: function () {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      var link = url.getSys("getconfig");
      $.get(link, params, (data) => {
        _this.loading = false;
        var form = _this.ensureEvaSummaryByEdu(data || {});
        if (!form.vipMenuProgress) form.vipMenuProgress = "申请进度";
        if (!form.vipMenuSuggest) form.vipMenuSuggest = "行前指导调查";
        if (!form.caseTabLang) form.caseTabLang = "语言学校";
        if (!form.caseTabGrad) form.caseTabGrad = "研究生预科";
        if (!form.caseTabPath) form.caseTabPath = "在日进路";
        _this.form = form;
      });
    },
    // 上传图片
    initImg: function() {
      var _this = this;
      if ($("#uploadBtnEva input").length == 0) {
        $("#uploadBtnEva").uploader({
          url: url.getUpload(),
          text: "上传图片",
          fileExts: "jpg;png",
          handleType: "0",
          maxSize: 1024 * 1024 * 0.5,
          onSuccess: function(data) {
            var src = url.getDomain() + data.relativeName;
            _this.$set(_this.form, "evaImage", data.relativeName);
          }
        });
      }
      if ($("#uploadBtnEvaBg input").length == 0) {
        $("#uploadBtnEvaBg").uploader({
          url: url.getUpload(),
          text: "上传背景图",
          fileExts: "jpg;png;webp",
          handleType: "0",
          maxSize: 1024 * 1024 * 1.5,
          onSuccess: function(data) {
            _this.$set(_this.form, "evaBgImg", data.relativeName);
          }
        });
      }
      if ($("#uploadBtnSchoolTop input").length == 0) {
        $("#uploadBtnSchoolTop").uploader({
          url: url.getUpload(),
          text: "上传顶图",
          fileExts: "jpg;png;webp",
          handleType: "0",
          maxSize: 1024 * 1024 * 1,
          onSuccess: function(data) {
            _this.$set(_this.form, "schoolTopImg", data.relativeName);
          }
        });
      }
      if ($("#uploadBtnVrComing input").length == 0) {
        $("#uploadBtnVrComing").uploader({
          url: url.getUpload(),
          text: "上传图片",
          fileExts: "jpg;png",
          handleType: "0",
          maxSize: 1024 * 1024 * 1,
          onSuccess: function(data) {
            _this.$set(_this.form, "vrComingSoonImg", data.relativeName);
          }
        });
      }
      if ($("#uploadBtnPageLoading input").length == 0) {
        $("#uploadBtnPageLoading").uploader({
          url: url.getUpload(),
          text: "上传加载图",
          fileExts: "jpg;png;gif;webp",
          handleType: "0",
          maxSize: 1024 * 1024 * 1,
          onSuccess: function(data) {
            _this.$set(_this.form, "pageLoadingImg", data.relativeName);
          }
        });
      }
    },
  

    //提交表单
    submitForm(formName) {
      var _this = this;
      var link = url.getSys("saveconfig");
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submiting = true;
          var info = Object.assign({}, this.form);
          // 题目配置已迁到「行前指导调查」页，这里不覆盖 suggestQuestionsJson
          $.post(link, info, (res) => {
            _this.submiting = false;
            if (res.status) {
              _this.$message({
                type: "success",
                message: res.msg,
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        } else {
          return false;
        }
      });
    },
  },
  mounted() {
    //获取服务器列表
    this.getConfig();
    this.initImg();
  },
};
</script>

<style>
.query-form {
  margin-top: 20px;
  padding-top: 25px;
  background: #f2f2f2;
}
.el-form-item--small.el-form-item {
  margin-right: 0px;
}
.el-button--primary {
  margin-left: 10px;
}
</style>
